import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RA } from "src/models/sisreg";
import { STATUS_RA } from "src/services/sisreg.service";

@Component({
  selector: "app-card-list-component",
  templateUrl: "./card-list-component.component.html",
  styleUrls: ["./card-list-component.component.scss"],
})
export class CardListComponentComponent implements OnInit {
  @Input("infoList") infoList: any[];
  @Output() acao = new EventEmitter();

  conteudoRevelado: boolean;

  constructor() { }

  ngOnInit() {
    console.log(this.infoList);
  }

  labelData(atendimento: RA) {
    const inicio = STATUS_RA[atendimento.status];

    switch (inicio.cor) {
      case "amarelo":
      case "vermelho":
      case "verde":
        if (atendimento.execucao)
          return `${inicio.label} em: ${atendimento.execucao.data}`;
      case "azulescuro":
        return `${inicio.label} em: ${atendimento.solicitacao.data}`;
      default:
        return `${inicio.label} em: ${atendimento.solicitacao.data}`;
    }
  }

  verificarStatus(status) {
    const blackList = ["Negado/Cancelado", "Em estado de erro", "Em espera"];
    return !blackList.includes(status);
  }

  gerar(acao) {
    this.acao.emit(acao);
  }
}
